// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__m8W0H","info":"PatientInfo_info__3ike3"};